module.exports = __webpack_public_path__ + "static/media/check-solid.20810638.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/check-solid.svg
// module id = 278
// module chunks = 2